import Svg, {Rect} from 'react-native-svg'

import {SPRITES} from '#/lib/brand/sprites'

/**
 * Renders a badge's pixel-art icon as an SVG <Rect> grid — the sprite half of
 * the community badges. Cross-platform (native + web) via react-native-svg; the
 * emoji `<Text>` path in BrandBadges stays the fallback for unknown icons.
 *
 * The sprite is authored on a 16-unit grid, so we draw into a `0 0 16 16`
 * viewBox with integer-coordinate rects and let the outer <Svg> scale uniformly
 * to `width` — no inter-rect seams, crisp at every badge size. A cell tagged
 * PRIMARY (value 1) is tinted with the badge's own `color`; every other cell
 * carries a fixed hex from the sprite's palette (outline, highlight, accents).
 */
export function BadgeSpriteSvg({
  icon,
  color,
  width,
}: {
  icon: string
  color: string
  width: number
}) {
  const sprite = SPRITES[icon]
  if (!sprite) return null

  type Cell = {x: number; y: number; w: number; fill: string}
  const cells: Cell[] = []
  sprite.g.forEach((row, y) => {
    let x = 0
    for (const [value, count] of row) {
      if (value !== 0) {
        cells.push({
          x,
          y,
          w: count,
          fill: value === 1 ? color : sprite.p[value - 2],
        })
      }
      x += count
    }
  })

  return (
    <Svg width={width} height={width} viewBox="0 0 16 16">
      {cells.map((c, i) => (
        <Rect key={i} x={c.x} y={c.y} width={c.w} height={1} fill={c.fill} />
      ))}
    </Svg>
  )
}
